import React, { useState } from 'react'
import COLORS from '../../styles/colors'

interface ISVGProps {
  dimensions?: {
    width: string | number
    height: string | number
  }
  color?: string
  className?: string
  hoverColor?: string
  onClick: () => void
}

const defaultDimensions = {
  width: 35,
  height: 35,
}

function Cancel({
  dimensions = defaultDimensions,
  color = '#adadad',
  className = '',
  hoverColor = COLORS.uiSpecific.danger,
  onClick,
}: ISVGProps) {
  const [IconColor, setIconColor] = useState<string>(color)

  const handleHover = (isMouseEntering) => {
    if (isMouseEntering) {
      setIconColor(hoverColor)
      document.body.style.cursor = 'pointer'
      return
    }

    setIconColor(color)
    document.body.style.cursor = 'default'
  }

  return (
    <div
      onMouseEnter={() => handleHover(true)}
      onMouseLeave={() => handleHover(false)}
      onClick={onClick}
    >
      <svg
        height={dimensions.height}
        width={dimensions.width}
        viewBox='0 0 34.999 34.999'
        className={className}
      >
        <path
          d='M29.874 5.125A17.5 17.5 0 005.126 29.874 17.5 17.5 0 0029.874 5.125zm-4.805 17.526a1.71 1.71 0 11-2.417 2.417l-5.151-5.152-5.152 5.152a1.71 1.71 0 01-2.418-2.416l5.152-5.152-5.152-5.152a1.71 1.71 0 012.417-2.417l5.153 5.152 5.152-5.152a1.71 1.71 0 012.417 2.417L19.917 17.5zm0 0'
          fill={IconColor}
        />
      </svg>
    </div>
  )
}

export default Cancel
